"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthWebInterceptor = void 0;
const AbstractAuthInterceptor_1 = require("../Interceptor/AbstractAuthInterceptor");
const TokenWebModel_1 = require("../Model/TokenWebModel");
class AuthWebInterceptor extends AbstractAuthInterceptor_1.AbstractAuthInterceptor {
    constructor(authClient, data) {
        super(authClient);
        this.authClient = authClient;
        this.tokenModel = new TokenWebModel_1.TokenWebModel(data);
    }
}
exports.AuthWebInterceptor = AuthWebInterceptor;
//# sourceMappingURL=AuthWebInterceptor.js.map